import { postForm, request } from './client'
import { USE_MOCK } from './config'
import { mockAuthApi } from './mock'

export interface LoginParams {
  telephone: string
  password: string
}

export interface User {
  user_id: string
  telephone: string
  username: string
  email: string
  user_type: number
  is_online: number
}

// Token management
const TOKEN_KEY = 'auth_token'

export function setToken(token: string) {
  localStorage.setItem(TOKEN_KEY, token)
}

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY)
}

export function removeToken() {
  localStorage.removeItem(TOKEN_KEY)
}

export const authApi = USE_MOCK ? mockAuthApi : {
  login: (params: LoginParams) =>
    postForm('/login', params),

  logout: () => {
    removeToken()
    return request('/loginOut', { method: 'GET' })
  },

  getOnlineStatistics: () =>
    request('/onlinestatistical', { method: 'POST' }),

  loginSkip: (token: string) =>
    request('/loginSkip', { method: 'GET', params: { token } }),

  // User management APIs
  getCurrentUser: () =>
    request('/auth/me', { method: 'GET' }),

  listUsers: () =>
    request('/users', { method: 'GET' }),

  createUser: (data: { username: string; password: string; display_name: string; role: string; phone?: string; email?: string }) =>
    request('/users', { method: 'POST', data: JSON.stringify(data), headers: { 'Content-Type': 'application/json' } }),

  updateUser: (id: number, data: Partial<{ display_name: string; role: string; phone: string; email: string; password: string }>) =>
    request(`/users/${id}`, { method: 'PUT', data: JSON.stringify(data), headers: { 'Content-Type': 'application/json' } }),

  deleteUser: (id: number) =>
    request(`/users/${id}`, { method: 'DELETE' }),
}
